<div class="py-10 px-5">
   <div class="flex">
      <h2 class="flex-auto">{{title}}</h2>
      <div class="justify-items-end">
         <button [mat-dialog-close]="null" class="flex-auto"> <mat-icon>close</mat-icon></button>
      </div>
   </div>

   <div class="pb-5">
      <div [innerHTML]="msg"></div>
   </div>
</div>

<div class="grid grid-flow-col h-[60px]">
   <button [mat-dialog-close]="null" class="btn-modal-cancel min-w-[150px]">
      <span class="label-btn-modal">{{btn_cancel}}</span>
   </button>

   <button [mat-dialog-close]="false" class="btn-modal-confirm-alt min-w-[150px]" *ngIf="show_confirm_alt">
      <span class="label-btn-modal">{{btn_confirm_alt}}</span>
   </button>

   <button [mat-dialog-close]="false" class="btn-modal-confirm-alt bg-red-600 hover:bg-red-700 min-w-[150px]" *ngIf="show_confirm_alt_red">
      <span class="label-btn-modal">{{btn_confirm_alt_red}}</span>
   </button>

   <button [mat-dialog-close]="true" cdkFocusInitial class="btn-modal-confirm min-w-[150px]" *ngIf="show_confirm">
      <span class="label-btn-modal">{{btn_confirm}}</span>
   </button>
</div>
